<script>
import { mapActions, mapGetters } from "vuex";

import ModalsTemplate from "../ModalsTemplate.vue";

import FacultyAddingType from "../FacultyAddingType.vue";

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    ModalsTemplate,
    FacultyAddingType,
  },

  data: () => ({
    object: {
      id: null,
      names: {
        uz: null,
        ru: null,
        en: null,
      },
      educationSchool: {
        id: null,
        name: null,
      },
      facultyTypes: [],
      active: true,
    },

    model: true,

    types: {},
    langs: {},

    isLoading: false,

    isInited: false,
  }),

  computed: {
    ...mapGetters("admin-schools", ["GET_SCHOOLS_ALL"]),
    schools: (vm) => vm.GET_SCHOOLS_ALL,

    ...mapGetters("admin-education-types", ["GET_EDUCATION_TYPES_ALL"]),
    ...mapGetters("admin-education-languages", ["GET_EDUCATION_LANGUAGE_ALL"]),
  },

  watch: {
    model() {
      setTimeout(() => {
        this.$emit("close");
      }, 100);
    },
  },

  created() {
    if (this.data?.id) {
      this.isLoading = true;
      this.isInited = false;
      this.FACULTY_BY_ID({ id: this.data.id })
        .then((data) => {
          if (data) this.object = data;
        })
        .finally(() => {
          this.isLoading = false;
          this.$nextTick(() => {
            this.isInited = true;
          });
        });
    } else {
      this.isInited = true;
    }
  },

  methods: {
    ...mapActions("admin-facultys", ["ADD_FACULTY", "FACULTY_BY_ID"]),
    onSend() {
      if (this.$refs.form.validate()) {
        this.object.educationSchool = this.schools.find(
          (x) => x.id === this.object.educationSchool.id
        );
        this.ADD_FACULTY(this.object).then((status) => {
          if (status != null) {
            this.$emit("refresh");
            this.model = false;
          }
        });
      }
    },
  },
};
</script>

<template>
  <modals-template
    :title="$t('Faculties')"
    :loading="isLoading"
    :width="800"
    v-model="model"
  >
    <v-form
      :disabled="isLoading"
      @submit.prevent="() => false"
      ref="form"
      lazy-validation
      v-if="isInited"
    >
      <v-row>
        <v-col cols="12">
          <v-select
            autofocus
            autocomplete="off"
            v-model="object.educationSchool.id"
            :items="schools"
            item-text="name"
            item-value="id"
            :rules="[$rules.required]"
            :label="$t('School')"
            required
            outlined
            hide-details
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            autocomplete="off"
            v-model="object.names.uz"
            :label="$t('Name uz')"
            :rules="[$rules.required]"
            required
            outlined
            hide-details
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            autocomplete="off"
            v-model="object.names.ru"
            :label="$t('Name ru')"
            :rules="[$rules.required]"
            required
            outlined
            hide-details
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            autocomplete="off"
            v-model="object.names.en"
            :label="$t('Name en')"
            outlined
            hide-details
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            autocomplete="off"
            v-model="object.mvdir"
            :label="'mvdir'"
            outlined
            hide-details
          />
        </v-col>
      </v-row>

      <faculty-adding-type
        v-model="object.facultyTypes"
        @loading="(v) => (isLoading = v)"
      />
    </v-form>

    <template slot="actions">
      <div class="d-flex w-100">
        <v-spacer />
        <v-btn color="primary" class="btn-accent" @click="onSend">
          {{ $t("Save") }}
        </v-btn>
      </div>
    </template>
  </modals-template>
</template>
